
import React, { useState } from 'react';
import Icon from './Icon';
// --- Header Component ---
const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navLinks = ["about", "experience", "projects", "skills", "contact"];
    return (
        <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/80 backdrop-blur-lg border-b border-slate-700/50">
            <div className="container mx-auto px-6 h-20 flex justify-between items-center">
                <a href="#hero" className="text-xl font-bold text-white tracking-wide">AG.</a>
                <nav className="hidden md:flex space-x-8">
                    {navLinks.map(link => <a key={link} href={`#${link}`} className="capitalize text-slate-300 hover:text-cyan-400 transition-colors duration-300">{link}</a>)}
                </nav>
                <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-white">
                    <Icon name={isMenuOpen ? "x" : "menu"} />
                </button>
            </div>
            {isMenuOpen && (
                <div className="md:hidden bg-slate-800">
                    <nav className="flex flex-col items-center space-y-4 py-4">
                        {navLinks.map(link => <a key={link} href={`#${link}`} onClick={() => setIsMenuOpen(false)} className="capitalize text-slate-300 hover:text-cyan-400 transition-colors">{link}</a>)}
                    </nav>
                </div>
            )}
        </header>
    );
};

export default Header;